import { Button } from '@user-portal/wikr-components';
import styled, { css } from 'styled-components';

import { color } from 'theme/selectors';

export const PrimaryButton = styled(Button)<typeof Button & { size?: string }>`
    ${({ isLoading, size }) => css`
        background-color: ${color('on-primary')};
        border-radius: 0;
        color: #ffffff;
        p {
            color: inherit !important;
        }
        svg path {
            fill: #ffffff;
        }

        &:hover:not(:disabled) {
            color: #ffffff;
            background-color: #373737;
        }
        &:active:not(:disabled) {
            background-color: #171717;
        }
        &:disabled {
            cursor: not-allowed;
            color: #e0e0ea;
            background-color: #646464;
            svg path {
                fill: #e0e0ea;
            }
        }

        ${isLoading &&
        css`
            &:disabled {
                background-color: #171717;
                color: #ffffff;
                svg path {
                    fill: #ffffff;
                }
            }
        `}

        ${size === 'small' &&
        css`
            border-radius: 6px;
            min-height: 44px;
        `}
    `}
`;

export const DefaultButton = styled(Button)<typeof Button>`
    border-radius: 0 !important;
`;
